
/**
 * Extract HTML email template from a message content
 */
export function extractMailTemplate(content: string): string | null {
  // Simple regex to extract HTML content between <html> tags
  const htmlMatch = content.match(/<html[^>]*>([\s\S]*?)<\/html>/i);
  
  if (htmlMatch && htmlMatch[0]) {
    return htmlMatch[0];
  }
  
  // Look for a complete HTML structure without html tags
  const bodyMatch = content.match(/<body[^>]*>([\s\S]*?)<\/body>/i);
  
  if (bodyMatch && bodyMatch[0]) {
    return `<html><head><meta charset="UTF-8"></head>${bodyMatch[0]}</html>`;
  }
  
  return null;
}

/**
 * Extract title from an email template or content
 */
export function extractEmailTitle(content: string): string {
  // Try to find a title tag
  const titleMatch = content.match(/<title[^>]*>([\s\S]*?)<\/title>/i);
  
  if (titleMatch && titleMatch[1]) {
    return titleMatch[1].trim();
  }
  
  // Try to find a subject line in the content
  const subjectMatch = content.match(/subject:([^\n\r]+)/i);
  
  if (subjectMatch && subjectMatch[1]) {
    return subjectMatch[1].trim();
  }
  
  // Fallback to first heading
  const headingMatch = content.match(/<h1[^>]*>([\s\S]*?)<\/h1>/i);
  
  if (headingMatch && headingMatch[1]) {
    return headingMatch[1].replace(/<[^>]*>/g, '').trim();
  }
  
  return 'Email Template';
}
